module.exports = __webpack_public_path__ + "static/media/icon_postal.d52d40bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_postal.svg
// module id = 1849
// module chunks = 0